import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import ResizeListener from "../../../../utility/ResizeListener";

import { CustomButton } from "../../../components/customButton/CustomButton";
import { CustomInput } from "../../../components/customInput/CustomInput";
import CustomDatePicker from "../../../components/custom_date_picker";
import { BlackClear, Clear } from "../../../resources/assetsManager";
import {
  WHITE_COLOR,
  LIGHT_GREY_BG_MODAL,
  BG_COLOR,
} from "../../../resources/colorsManager";
import { SUCCESS } from "../../../resources/constantsManager";
import { schedulerTypeDropdown } from "../../../resources/dropdownData";
function GenerateReportModalBody({ onClose, onSuccess }) {
  const [type, setType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [disabled, setDisabled] = useState(true);
  const { width } = ResizeListener();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const inputStyle = {
    backgroundColor: LIGHT_GREY_BG_MODAL,
    alignSelf: "center",
    flex: 1,
    marginBottom: 15,
    height: 45,
    width: "80%",
    boxShadow: "none",
  };

  const onClickAdddSchedule = () => {
    setLoading(true);
    ApiRequestPost.generateReports({
      fromDate,
      toDate,
      txnType: type,
    })
      .then((res) => {
        if (res.status === SUCCESS) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    if (toDate !== "" && fromDate !== "" && type !== "") {
      setDisabled(false);
    } else setDisabled(true);
  }, [toDate, fromDate, type]);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 30px",
        backgroundColor: WHITE_COLOR,
        minWidth: 300,
        minHeight: 400,
        borderRadius: 7,
        width: width * 0.3,
        // alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
          }}
        >
          Generate Reports
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: BG_COLOR,
            padding: 10,
            borderRadius: 6,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <img src={BlackClear} />
        </div>
      </div>
      <CustomDatePicker
        onChangeDate={(date) => {
          setFromDate(date);
        }}
        title="From"
        style={{
          backgroundColor: BG_COLOR,
        }}
      />

      <CustomDatePicker
        onChangeDate={(date) => {
          setToDate(date);
        }}
        title="To"
        style={{
          backgroundColor: BG_COLOR,
        }}
      />

      <CustomInput
        options={schedulerTypeDropdown}
        value={type}
        onChange={(data) => setType(data)}
        type="select"
        inputStyles={{
          backgroundColor: BG_COLOR,
          height: 50,
          width: "100%",
          borderRadius: 5,
          padding: 0,
          margin: 0,
          maxWidth: "100%",
          minWidth: 100,
        }}
        dropdownStyle={{
          width: "100%",
          padding: 0,
          margin: 0,
        }}
      />
      <CustomButton
        title="Add"
        loading={loading}
        styles={{
          marginTop: 20,
          width: "100%",
          height: 45,
          borderRadius: 2,
        }}
        textStyle={{
          color: WHITE_COLOR,
        }}
        onClick={() => {
          onClickAdddSchedule();
        }}
        disabled={disabled}
      />
    </div>
  );
}

export default GenerateReportModalBody;
